import { render } from "./referencesView.vue?vue&type=template&id=526da290&scoped=true"
import script from "./referencesView.vue?vue&type=script&lang=js"
export * from "./referencesView.vue?vue&type=script&lang=js"

import "./referencesView.vue?vue&type=style&index=0&id=526da290&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526da290"]])

export default __exports__